export default {
  /**
   * @description 配置显示在浏览器标签的title
   */
  title: '微比特软件',

  /** 公司名称 */
  name: '青岛微比特软件有限公司',
  /** 公司微信 */
  wechat: '青岛微比特软件有限公司',
  /** 公司邮箱 */
  email: 'biz@tinybit.cn',
  /** 公司手机 */
  phone: '13506396897 ',
  /** 公司电话 */
  tel: '13506396897 ',
  /** 公司地址 */
  address: '山东省青岛市市南区宁夏路288号青岛软件园2号楼5层C1区',
  /** 备案号 */
  keepOnRecordIcp: '-------------------',

  /** 百度地图相关信息 */
  BDMapInfo: {
    longitude: 120.419854,
    latitude: 36.082681,
    title: '软件园2号楼',
    address: '青岛市市南区宁夏路288号青岛软件园2号楼5层C1区'
  }
}



// WEBPACK FOOTER //
// ./src/config/index.js